import { schema } from 'normalizr';
import { arrayOfBarbers } from '../../main/barbers/schema';

export const shop = new schema.Entity('shops', {
  barbers: arrayOfBarbers,
});
export const arrayOfShops = new schema.Array(shop);
